import '@/config/appInsights'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initMonitoring } from '@/services/monitoringService'

// Initialise Azure Application Insights (no-op in dev unless key is set)
initMonitoring()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found in index.html')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
)
